<script lang="ts">
	import { onMount } from "svelte";
	import { push } from "svelte-spa-router";
	import { publishPresentation } from "../actions/publishPresentation";

	let { presentationId }: { presentationId: string } = $props();

	onMount(() => {
		if (presentationId) {
			publishPresentation(presentationId).then(
				() => {
					push("/");
				},
				(error) => {
					// TODO: surface this error in the UI. Currently the
					// page just hangs on "Publishing your presentation,
					// please wait…" forever if the publish fails. Logging
					// here at least makes the failure investigable from
					// devtools instead of dropping it silently.
					console.error("publishing presentation failed", error);
				},
			);
		} else {
			push("/");
		}
	});
</script>

<h2>Publishing your presentation, please wait...</h2>
